import IEditableProps from '../../../utilities/IEditableProps';
import React, { forwardRef } from 'react';
import IStyledProps from 'src/utilities/IStyledProps';
import styled from 'styled-components';
import classNames from 'classnames';
import HelpStyles from './helpStyles';

interface IHelpCenterQuestionProps extends IEditableProps, IStyledProps {
    question: string;
    children;
}

const HelpCenterQuestionContainer = styled.div<{ ref: any}>`
    .helpcenter-question {
        font-family: "National2";
        font-size: 2.222rem;
        font-weight: 350;
        color: #000;
    }
    .helpcenter-answer {
        font-family: "National2";
        font-size: 1rem;
        font-weight: 300;
    }
`

export const HelpCenterQuestion = forwardRef((props: IHelpCenterQuestionProps, ref) => {
    return (
        <HelpCenterQuestionContainer data-id={props.cmsId} ref={ref} className={classNames(props.editorClassObj)}>
            <HelpStyles />
            <div className="mb-3">
                <h1 className="helpcenter-question">Q: {props.question}</h1>
            </div>
            <div className='helpcenter-answer'>
                {props.children}
            </div>
        </HelpCenterQuestionContainer>
    )
});